import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
.use(router)
.use(ElementPlus)
.mount('#app')

import { Store } from './utils/store'
window.onresize = function() {
  Store.changeScreen();
}
